'use client';

import React from 'react';
import { FlaskConical } from 'lucide-react';

export default function VisualLabHeader() {
  return (
    <div className="flex items-start justify-between">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-purple-950/40 border border-purple-700/40 rounded flex items-center justify-center">
          <FlaskConical size={20} className="text-purple-400" />
        </div>
        <div>
          <p className="section-label mb-0.5">KI-Bildgenerierung</p>
          <h1 className="text-2xl font-800 text-white tracking-tight">Visual Lab</h1>
          <p className="text-sm text-muted mt-0.5">
            Markenspezifische Visuals generieren · Brand Vault: <span className="text-accent mono">Berger GmbH</span>
          </p>
        </div>
      </div>
    </div>
  );
}